import * as bootstrap from 'bootstrap';
import * as tempusDominus from '@eonasdan/tempus-dominus';

window.bootstrap = bootstrap;

import ConfirmDialogExtension from '../confirmDialog/index.js';
import DocumentForm from "@/controls/document";
import { hasPendingSubmit } from "@/controls/requestScope";

/**
 * Součet ceny a poplatků zaokrouhlený na setiny.
 * Bez zaokrouhlení vzniká artefakt plovoucí čárky (1419.32 + 3.36 = 1422.6799999999998),
 * který maska cenových polí (IMask, scale 4) usekne na 1422.6799 místo 1422.68.
 */
function sumPriceWithFees(price, feeRecycle, feeCopyright) {
    const sum = (parseFloat(price) || 0) + (parseFloat(feeRecycle) || 0) + (parseFloat(feeCopyright) || 0);
    return Math.round(sum * 100) / 100;
}

class InvoiceForm {
    constructor() {
        this.uncompletedDocumentSelector = '#uncompletedDocument';
        InvoiceForm.instance = this;

        this.initInvoiceDetail();
        this.initInvoiceGetContactDetail();
        this.initInvoiceItemAutocomplete();

        // pro funkčnost i pro inline-edit by měla být funkce zde, ale dochází k error voláním a potenciálnímu zamrznutí aplikace.
        // dořešit pokud bude potřeba plně navázat funkcionality i při inline-edit
        // this.initInvoiceItemRowBehavior();

        this.waitForInlineOperationsToFinish().then(() => {
            this.tryOpenInlineAdd();
            this.initInvoiceItem();

            this.initInvoiceItemRowBehavior();
            this.initSerialNumberEvents();
            this.initStoreCardListener();
            this.initAccountCodingListener();
        });


        this.lastQuery = '';
        this.activeRequest = null;
        this.isLoading = false;
        this.debounceTimer = null;
        this.requestSeq = 0;
    }

    // Metoda pro čekání na dokončení inline operací
    waitForInlineOperationsToFinish() {
        return new Promise(resolve => {
            const checkCondition = () => {
                // Čekáme jen na dokončení inline EDITACE – otevřený inline-add řádek
                // je cílový stav (viz stejná úprava v controls/document).
                if (document.querySelector('input[name="inline_edit[submit]"]') === null) {
                    resolve();
                } else {
                    setTimeout(checkCondition, 300);
                }
            };

            checkCondition();
        });
    }

    tryOpenInlineAdd() {
        //zrušeno, automaticky se neotevře přidano nové položky
        // if ($('.disable-check-store-card-exists').length) return;
        const gridWrapper = document.querySelector('.datagrid-wrapper');
        const completeBtn = document.querySelector('#snippet-editTabs-tabContent-polozky-tabControl-grid-grid-grid');

        if (!gridWrapper || !completeBtn) return;

        if (gridWrapper.querySelector('.datagrid-row-inline-add')) {
            var newInput = document.getElementById('invoice-item-name');
            if (!newInput) {
                newInput = document.getElementById('document-item-name');
            }

            if (newInput) {
                const active = document.activeElement;
                const isInputFocused = active && (
                    active.tagName === 'INPUT' ||
                    active.tagName === 'TEXTAREA' ||
                    active.isContentEditable
                );
                const isOtherInputFocused = active && active !== newInput && (
                    active.tagName === 'INPUT' ||
                    active.tagName === 'TEXTAREA' ||
                    active.tagName === 'SELECT' ||
                    active.isContentEditable
                );
                const isIframeInputOpen = !!document.querySelector('.iframe-input--open');

                if (!isInputFocused && !isOtherInputFocused && !isIframeInputOpen) {
                    newInput.focus();
                }

                if (window.innerWidth < 767) {
                    // console.log('scoll inv');
                    newInput.scrollIntoView({ behavior: 'auto', block: 'start' });
                    window.scrollBy({
                        top: 10,
                        behavior: 'auto'
                    });
                }
                // obs.disconnect();
            }
            return;
        }

        const showInlineAddLink = gridWrapper.querySelector('a[href*="showInlineAdd"]');
        if (showInlineAddLink) {
            // Dokud běží ukládání, inline řádek neotevíráme (viz controls/document,
            // tiket 854 – auto-klik abortoval submit a spolkl redirect).
            if (hasPendingSubmit()) {
                return;
            }

            // Debounce přes modulový stav – atribut na odkazu nepřežije překreslení
            // snippetu, takže původní pojistka nefungovala.
            const now = Date.now();
            if (now - (InvoiceForm._lastInlineAddClickAt || 0) < 1000) {
                return;
            }
            InvoiceForm._lastInlineAddClickAt = now;

            // Vlastní abort bucket: auto-klik smí zrušit jen předchozí auto-klik.
            showInlineAddLink.setAttribute('data-naja-unique', 'inline-add');
            naja.uiHandler.clickElement(showInlineAddLink);
        }
    }

    pad(n){ return String(n).padStart(2,'0'); }
    formatDate(d){ return `${this.pad(d.getDate())}.${this.pad(d.getMonth()+1)}.${d.getFullYear()}`; }
    formatDateTime(d){ return `${this.formatDate(d)} ${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`; }

    getWantClock(el){
        const t = el?.dataset?.originalType;
        return (t && t !== 'date') || /\d{1,2}:\d{2}/.test(el?.value || '');
    }

    parseDisplayValue(str, wantClock){
        if (!str) return null;
        const s = str.trim();
        // dd.MM.yyyy [HH:mm[:ss]]
        let m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
        if (m){
            let [, dd, mm, yyyy, hh='0', mi='0', ss='0'] = m;
            return new Date(+yyyy, +mm-1, +dd, wantClock ? +hh : 0, wantClock ? +mi : 0, wantClock ? +ss : 0, 0);
        }
        // fallback: YYYY-MM-DD[ T]HH:mm[:ss]
        const norm = s.replace(' ', 'T'); const [d,t] = norm.split('T');
        const [y,mo,da] = (d||'').split('-').map(Number);
        if(!y||!mo||!da) return null;
        let hh=0, mi=0, ss=0;
        if (wantClock && t){
            const arr = t.split(':').map(v=>parseInt(v,10)||0);
            [hh,mi,ss] = [arr[0]||0, arr[1]||0, arr[2]||0];
        }
        return new Date(y, mo-1, da, hh, mi, ss, 0);
    }

    getDateFromInput(el){
        if (!el) return null;
        const wantClock = this.getWantClock(el);
        return this.parseDisplayValue(el.value, wantClock);
    }

    setDateToInput(el, jsDate){
        if(!el || !jsDate || isNaN(jsDate.getTime())) return;
        if (el._td){
            el._td.dates.setValue(new tempusDominus.DateTime(jsDate));
        } else {
            el.value = this.getWantClock(el) ? this.formatDateTime(jsDate) : this.formatDate(jsDate);
        }
        el.dispatchEvent(new Event('input',  {bubbles:true}));
        el.dispatchEvent(new Event('change', {bubbles:true}));
    }

    initInvoiceDetail() {

        this.dateIssueInput    = document.getElementById('date-issue');
        this.maturityInput     = document.getElementById('maturity');       // počet dní
        this.dateMaturityInput = document.getElementById('date-maturity');  // datum splatnosti
        this.deferredDateInput = document.getElementById('deferred-date');  // odložené datum
        this.dateTaxableInput  = document.getElementById('date-taxable');   // DUZP

        if (!this.maturityInput || !this.dateMaturityInput || !this.deferredDateInput) return;

        if (!this.maturityInput.classList.contains('input-listener-attached')) {
            this.maturityInput.classList.add('input-listener-attached');
            this.maturityInput.addEventListener('input', () => this.updateDateMaturity());
        }

        if (!this.dateMaturityInput.classList.contains('input-listener-attached')) {
            this.dateMaturityInput.classList.add('input-listener-attached');
            this.dateMaturityInput.addEventListener('input', () => this.updateMaturity());
        }

        if(this.deferredDateInput) {
            if (!this.deferredDateInput.classList.contains('input-listener-attached')) {
                this.deferredDateInput.classList.add('input-listener-attached');
                this.deferredDateInput.addEventListener('input', () => {
                    if(this.deferredDateInput.value){
                        this.dateIssueInput.disabled = true;
                        this.dateIssueInput.value = '';
                    }
                    else{
                        this.dateIssueInput.disabled = false;
                        this.dateIssueInput.value = new Date().toISOString().slice(0, 10);
                    }
                    this.updateDateMaturity();
                    this.updateDateTaxable();
                });
            }
        }

        this.documentTypeSelect = document.getElementById('invoice-document-type-select');
        this.generateSelect = document.getElementById('invoice-generate-select');

        const lockGenerate = (locked) => {
            if (locked) {
                this.generateSelect.value = 'none';
                this.generateSelect.dataset.locked = '1';
                this.generateSelect.style.pointerEvents = 'none';
                this.generateSelect.classList.add('bg-disabled');
            } else {
                this.generateSelect.dataset.locked = '0';
                this.generateSelect.style.pointerEvents = '';
                this.generateSelect.classList.remove('bg-disabled');
            }
        };

        // inicializace
        if (this.documentTypeSelect.value === 'FV') {
            lockGenerate(true);
        } else {
            lockGenerate(false);
        }

        if (this.documentTypeSelect && this.generateSelect) {
            this.documentTypeSelect.addEventListener('change', () => {
                if (this.documentTypeSelect.value === 'ZFV') {
                    this.generateSelect.value = 'generateInvoice';
                    lockGenerate(false);
                } else {
                    lockGenerate(true);
                }
            });
        }

    }

    initInvoiceItem() {
        var isEdit = document.querySelector('input[name="inline_edit[submit]"]');
        if (!isEdit && document.querySelector('input[name="inline_add[submit]"]') === null) {
            return;
        }
        var row = isEdit ? document.querySelector('input[name="inline_edit[submit]"]').closest('tr') : document.querySelector('input[name="inline_add[submit]"]').closest('tr');
        if (row.querySelector('#invoice-item-count')) {
            this.invoiceItemRepayment = document.getElementById('invoice-item-repayment');
            this.invoiceItemCount = document.getElementById('invoice-item-count');
            this.invoiceItemTaxRate = document.getElementById('invoice-item-tax-rate');
            this.invoiceItemPrice = document.getElementById('invoice-item-price');
            this.invoiceItemDiscount = document.getElementById('invoice-item-discount');
            this.invoiceItemPriceBase = document.getElementById('invoice-item-price-base');
            this.invoiceItemPricePurchase = document.getElementById('invoice-item-price-purchase')
            this.invoiceItemPricePurchaseBase = document.getElementById('invoice-item-price-purchase-base');
            this.invoiceItemPriceSale = document.getElementById('invoice-item-price-sale');
            this.invoiceItemPriceSaleTax = document.getElementById('invoice-item-price-sale-tax');
            this.invoiceItemPriceSaleTotal = document.getElementById('invoice-item-price-sale-total');
            this.invoiceItemPriceTotal = document.getElementById('invoice-item-price-total');
            this.invoiceItemCountAvailable = document.getElementById('invoice-item-count-available');
            this.invoiceItemFees = document.getElementById('invoice-item-fees');
        } else {
            this.invoiceItemRepayment = document.getElementById('document-item-repayment');
            this.invoiceItemCount = document.getElementById('document-item-count');
            this.invoiceItemTaxRate = document.getElementById('document-item-tax-rate');
            this.invoiceItemPrice = document.getElementById('document-item-price');
            this.invoiceItemDiscount = document.getElementById('document-item-discount');
            this.invoiceItemPriceBase = document.getElementById('document-item-price-base');
            this.invoiceItemPricePurchase = document.getElementById('document-item-price-purchase')
            this.invoiceItemPricePurchaseBase = document.getElementById('document-item-price-purchase-base');
            this.invoiceItemPriceSale = document.getElementById('document-item-price-sale');
            this.invoiceItemPriceSaleTax = document.getElementById('document-item-price-sale-tax');
            this.invoiceItemPriceSaleTotal = document.getElementById('document-item-price-sale-total');
            this.invoiceItemPriceTotal = document.getElementById('document-item-price-total');
            this.invoiceItemCountAvailable = document.getElementById('document-item-count-available');
            this.invoiceItemFees = document.getElementById('document-item-fees');
        }

        this.invoiceItemEditInput = row.querySelector('.invoice-item-edit-btn');

        if (this.invoiceItemRepayment && this.invoiceItemRepayment.classList.contains('form-control')) {
            this.invoiceItemRepayment.classList.remove('form-control');
        }
        if (this.invoiceItemRepayment && this.invoiceItemRepayment.classList.contains('form-control-sm')) {
            this.invoiceItemRepayment.classList.remove('form-control-sm');
        }

        var inputs = [
            this.invoiceItemCount,
            this.invoiceItemTaxRate,
            this.invoiceItemPrice,
            this.invoiceItemDiscount,
            this.invoiceItemPriceSale,
            this.invoiceItemPricePurchase,
            this.invoiceItemPriceBase,
            this.invoiceItemPriceTotal
        ];

        inputs.forEach(input => {
            if (input && !input.classList.contains('price-listener-attached')) {
                input.classList.add('price-listener-attached');
                input.addEventListener('input', () => this.updateInvoiceItemPrice());
            }
        });

        if (this.invoiceItemCount && this.invoiceItemCountAvailable) {
            ['input', 'change'].forEach(eventType => {
                this.invoiceItemCount.addEventListener(eventType, () => this.validateItemCount());
            });
        }
    }

    validateItemCount() {
        var count = parseFloat(this.invoiceItemCount?.value || '0', 10);
        var countAvailable = parseFloat(this.invoiceItemCountAvailable?.value || '0', 10);

        // sklad povoluje výdej do záporu - počet nesrážíme, upozornění až při uložení řádku
        if (this.invoiceItemRepayment?.checked || this.allowsNegativeOutput()) {
            return;
        }

        // záporný stav nesmí počet převrátit do mínusu - z prodeje by se stala vratka
        countAvailable = Math.max(countAvailable, 0);
        if (!isNaN(count) && !isNaN(countAvailable) && count > countAvailable) {
            this.invoiceItemCount.value = countAvailable;
            this.updateInvoiceItemPrice();
            alert(`Není dostatek zboží skladem. Maximální počet upraven na ${countAvailable}.`);
        }
    }

    // Sklad dokladu povoluje výdej do záporu (data-allow-negative z gridu); neplatí pro karty se sériovými čísly
    allowsNegativeOutput() {
        if (this.invoiceItemCount?.dataset.allowNegative !== '1') {
            return false;
        }
        var serialNumberInput = document.getElementById('invoice-item-serial-number') || document.getElementById('document-item-serial-number');
        return !serialNumberInput || serialNumberInput.disabled;
    }

    initInvoiceItemAutocomplete() {
        this.invoiceItemNameInput = document.getElementById('invoice-item-name');
        if (!this.invoiceItemNameInput || this.invoiceItemNameInput.classList.contains('autocomplete-attached')) return;

        if(this.invoiceItemNameInput.dataset.storecardPrepared === '1'){
            this.setupInvoiceItemEditBtn();
            document.getElementById('invoice-item-count').select();
            document.getElementById('invoice-item_add-store-card').value = this.invoiceItemNameInput.dataset.storecardId;
        }
        else{
            if(document.getElementById('invoice-item_add-store-card')){
                document.getElementById('invoice-item_add-store-card').value = '';
            }
        }
        this.invoiceItemNameInput.classList.add('autocomplete-attached');
        this.suggestionsContainer = document.getElementById('suggestions-container') || this.createSuggestionsContainer();

        this.invoiceItemNameInput.addEventListener('click', () => {
            this.loadSuggestions(true);
        });

        // Upravená implementace pro klávesovou navigaci
        this.invoiceItemNameInput.addEventListener('keydown', event => {
            // Navigace pomocí šipek
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault(); // Zabránit posunu kurzoru v textovém poli

                if (this.suggestionsContainer.style.display === 'flex') {
                    var items = this.suggestionsContainer.querySelectorAll('.list-group-item');
                    if (items.length === 0) return;

                    var highlighted = this.suggestionsContainer.querySelector('.list-group-item.highlighted');
                    let index = -1;

                    if (highlighted) {
                        index = Array.from(items).indexOf(highlighted);
                        highlighted.classList.remove('highlighted');
                        highlighted.style.backgroundColor = 'rgb(232, 245, 252)';

                        if (event.key === 'ArrowDown') {
                            index = (index + 1) % items.length;
                        } else {
                            index = (index - 1 + items.length) % items.length;
                        }
                    } else {
                        index = event.key === 'ArrowDown' ? 0 : items.length - 1;
                    }

                    var newHighlighted = items[index];
                    newHighlighted.classList.add('highlighted');
                    //newHighlighted.style.background = '#f0f0f0';

                    // Zajistíme, že je vybraná položka viditelná
                    newHighlighted.scrollIntoView({block: 'nearest'});
                }
                return;
            }

            // Výběr položky pomocí klávesy Enter
            if (event.key === 'Enter') {
                var highlighted = this.suggestionsContainer.querySelector('.list-group-item.highlighted');

                if (highlighted && this.suggestionsContainer.style.display === 'flex') {
                    event.preventDefault();
                    highlighted.click(); // Spustí kliknutí na zvýrazněnou položku
                    return;
                } else {
                    if ($('.disable-check-store-card-exists').length == 0) {
                        event.preventDefault();
                        this.invoiceItemCount.value = 1;
                        this.suggestionsContainer.innerHTML = '';
                        this.suggestionsContainer.style.display = 'none';
                        this.invoiceItemCount.select();
                        this.showAddProductModal();
                    }
                }
            }
        });

        this.invoiceItemNameInput.addEventListener('keyup', (event) => {
            // Přeskočit tyto klávesy, protože jsou zpracovány v keydown
            if (['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) return;
            this.loadSuggestions();
        });

        this.invoiceItemNameInput.addEventListener('blur', () => {
            setTimeout(() => {
                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';
            }, 200);
        });
    }

    initInvoiceGetContactDetail() {
        this.invoiceIssuedForInput = document.getElementById('invoice-issued-for');

        if (!this.invoiceIssuedForInput) {
            return;
        }

        this.invoiceIssuedForInput.onchange = () => {
            const contactId = this.invoiceIssuedForInput.value;
            const provide = this.invoiceIssuedForInput.getAttribute('data-provide');
            if (contactId) {
                naja.makeRequest('POST', provide, {contactId}, {history: false})
                    .then(response => {
                        document.getElementById('maturity').value = response.maturity || 30;
                        document.getElementById('invoice-payment-method').value = response.paymentMethod || 'převodem';
                        this.updateDateMaturity();
                    })
            }
        };
    }

    showAddProductModal() {
        if ($('.disable-check-store-card-exists').length) return;

        var confirmDialog = new ConfirmDialogExtension();
        confirmDialog.showConfirmDialog(
            'Tento produkt nebyl nalezen. Chcete vytvořit novou kartu produktu?',
            (newTab) => {
                var invoiceItemEditInput = document.getElementById('invoice-item-edit');
                var productName = encodeURIComponent(this.invoiceItemNameInput.value);
                // var url = `/main/store/catalog?name=${productName}`;

                //  window.open(url, '_blank');

                var link = invoiceItemEditInput.getAttribute('data-link') + `&name=${productName}`;
                if (link) {
                    // var storeCardId = document.getElementById('invoice-item_add-store-card').value;
                    // var updatedLink = link.replace('ITEM_ID', storeCardId);
                    naja.makeRequest('GET', link, null, {
                        history: false
                    }).then(() => {
                        var modal = document.getElementById('modal-store-catalog-edit-info');
                        if (modal) {
                            var bsModal = new bootstrap.Modal(modal);
                            bsModal.show();
                        }
                        this.initModalEvents(modal, null);
                    });
                }
            },
            () => {
                this.invoiceItemNameInput.focus();
            },
            true
        );
    }

    initInvoiceItemRowBehavior() {
        document.querySelectorAll('.datagrid-wrapper tr').forEach(row => {
            // Získat všechny vstupy kromě submit tlačítka
            var inputs = row.querySelectorAll('input:not([type="submit"]), select, textarea');
            var submitButton = row.querySelector('input[name="inline_add[submit]"], input[name="inline_edit[submit]"]');
            var form = row.closest('form');

            if (row.querySelector('[id^="device-transfer-item-"]')) {
                return;
            }

            if (submitButton && !submitButton.classList.contains('submit-listener-attached')) {
                submitButton.classList.add('submit-listener-attached');

                // Zabráníme standardnímu zpracování NAJA - zachytíme událost před ní
                submitButton.addEventListener('click', this.handleSubmitValidation.bind(this), true);
            }

            inputs.forEach(input => {
                if (!input.classList.contains('enter-listener-attached')) {
                    input.classList.add('enter-listener-attached');

                    // Zachycení před standardním zpracováním
                    input.addEventListener('keydown', this.handleEnterKeyValidation.bind(this, row, submitButton), true);
                }
            });
        });

        document.querySelectorAll('.datagrid-wrapper form').forEach(row => {
            // Získat všechny vstupy kromě submit tlačítka
            var inputs = row.querySelectorAll('input:not([type="submit"])');

            inputs.forEach((input, index) => {
                if (!input.classList.contains('enter-listener-attached')) {
                    input.classList.add('enter-listener-attached');

                    input.addEventListener('keydown', function (event) {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            const next = inputs[index + 1];
                            if (next) {
                                next.focus();
                                if (typeof next.select === 'function') {
                                    try {
                                        next.select();
                                    } catch (e) {}
                                }
                            }
                        }
                    }, true);
                }
            });
        });

        // Zbytek metody zůstává nezměněn
        if (!naja.__inlineAddFocusBound) {
            naja.addEventListener('complete', () => {
                var observer = new MutationObserver((mutations, obs) => {
                    var newInput = document.getElementById('invoice-item-name');
                    if (newInput) {
                        const active = document.activeElement;
                        const isInputFocused = active && (
                            active.tagName === 'INPUT' ||
                            active.tagName === 'TEXTAREA' ||
                            active.isContentEditable
                        );
                        const isOtherInputFocused = active && active !== newInput && (
                            active.tagName === 'INPUT' ||
                            active.tagName === 'TEXTAREA' ||
                            active.tagName === 'SELECT' ||
                            active.isContentEditable
                        );
                        const isIframeInputOpen = !!document.querySelector('.iframe-input--open');

                        if (!isInputFocused && !isOtherInputFocused && !isIframeInputOpen) {
                            newInput.focus();
                        }

                        obs.disconnect();
                    }
                });

                observer.observe(document, {childList: true, subtree: true});
            });

            naja.__inlineAddFocusBound = true;
        }
    }

// Aktualizace metody initSerialNumberEvents pro komunikaci s nově vytvořenými funkcemi
    initSerialNumberEvents() {
        window.serialNumberModalState = {
            isModalOpening: false,
            isModalOpen: false,
            lastInput: null
        };


        // Přidat globální posluchač pro klávesu Enter
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === 'Tab') {
                // Kontrola, zda se jedná o pole sériových čísel
                var isSerialNumberField =
                    event.target.id === 'invoice-item-serial-number' ||
                    event.target.name === 'inline_add[serialNumber]' ||
                    event.target.name === 'inline_edit[serialNumber]';

                // Kontrola, zda je otevírané nebo otevřené modální okno
                var isModalActive =
                    window.serialNumberModalState?.isModalOpening ||
                    window.serialNumberModalState?.isModalOpen;

                // Kontrola, zda aktuální pole odpovídá poslednímu poli sériových čísel
                var isLastField =
                    window.serialNumberModalState?.lastInput === event.target;

                // Blokovat klávesu Enter pouze pokud:
                // 1. Je to pole sériových čísel A
                // 2. Modální okno je aktivní nebo se otevírá A
                // 3. Aktuální pole odpovídá poslednímu poli sériových čísel
                if (isSerialNumberField && isModalActive && isLastField) {
                    console.log('Blokuji klávesu Enter na poli sériových čísel během práce s modálním oknem');
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
            }
        }, true);

        if (document.body.hasAttribute('serial-number-events-initialized')) {
            return;
        }
        document.body.setAttribute('serial-number-events-initialized', 'true');

        document.addEventListener('click', (e) => {
            var target = e.target;
            if (target.id === 'invoice-item-serial-number' && !target.disabled) {
                e.preventDefault();
                this.openSerialNumberModal(target);
            }
        });

        if (!window.najaSerialNumberListenerInitialized) {
            window.najaSerialNumberListenerInitialized = true;

            naja.addEventListener('success', (event) => {
                var {payload} = event.detail;

                if (payload && payload.serialNumbers !== undefined && window.lastClickedSerialNumberInput) {
                    window.lastClickedSerialNumberInput.value = payload.serialNumbers;

                    const count = payload.serialNumbers.split(',').filter(sn => sn.trim() !== '').length;

                    const tr = window.lastClickedSerialNumberInput.closest('tr');
                    if (tr) {
                        const countInput = tr.querySelector('input[name="inline_edit[count]"]')
                            || tr.querySelector('input[name="inline_add[count]"]');
                        if (countInput) {
                            countInput.value = count;
                            countInput.dataset.serialNumbersResult = 'true'; // Přidáme příznak, že aktualizace počtu byla dokončena
                        }
                    }

                    this.updateInvoiceItemPrice();
                }
            });
        }
    }

    // Upravme metodu zpracování sériových čísel při zavření modálního okna
    processSerialNumberSelection(modal) {
        // Implementace zpracování výběru sériových čísel...

        // Nastavit příznak aktualizace sériových čísel
        window.serialNumbersUpdated = true;

        // Další kód pro zpracování sériových čísel...
    }


    // Ověření, zda existuje tlačítko pro odeslání před jeho použitím
    handleSubmitValidation(event) {
        // Zkontrolovat, zda je splněna podmínka pro sériová čísla
        var serialNumberInput = document.getElementById('invoice-item-serial-number');

        // Pokud byl formulář nedávno odeslán prostřednictvím modálního okna sériových čísel, povolit odeslání
        if (window.serialNumbersUpdated === true) {
            window.serialNumbersUpdated = false;
            return true;
        }

        // Pokud je pole sériových čísel povinné, ale prázdné, zabránit odeslání
        if (serialNumberInput && !serialNumberInput.disabled && (!serialNumberInput.value || serialNumberInput.value.trim() === '')) {
            event.preventDefault();
            event.stopPropagation();

            // Zobrazit upozornění
            alert('Prosím vyplňte sériové číslo.');

            // Otevřít modální okno pro výběr sériových čísel
            this.openSerialNumberModal(serialNumberInput);
            return false;
        }

        if ($('.disable-check-store-card-exists').length == 0) {
            // Kontrola, zda existuje storeCard
            var storeCardId = document.querySelector('[name="inline_edit[_id]"]')?.value;
            if (!storeCardId) {
                storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
            }
            if (!storeCardId || storeCardId === '') {
                event.preventDefault();
                event.stopPropagation();

                this.showAddProductModal();
                return false;
            }
        }

        // Ostatní kontroly
        return this.checkCountAndCountAvailable(event);
    }


    handleEnterKeyValidation(row, submitButton, event) {
        // console.log('handleEnterKeyValidation');
        if (event.target.hasAttribute('data-datagrid-manualsubmit')) {
            return;
        }

        var editableInputs = Array.from(row.querySelectorAll('input:not([type="submit"]):not([type="hidden"]), select, textarea'))
            .filter(input => !input.readOnly && !input.disabled);

        var currentInput = event.target;
        var currentIndex = editableInputs.indexOf(currentInput);

        var isLastInput = currentIndex === editableInputs.length - 1;
        var isCountEnterFinish = event.target.classList.contains('count-enter-finish');
        var serialNumberFieldExists = false;

        var serialNumberField = row.querySelector('#invoice-item-serial-number');
        if (serialNumberField && !serialNumberField.disabled) {
            serialNumberFieldExists = serialNumberField;
        }

        if (event.key === 'Enter') {
            if (($('.disable-check-store-card-exists').length == 0 || ($('.disable-check-store-card-exists').length && $('.highlighted').length != 0)) && this.suggestionsContainer && this.suggestionsContainer.style.display === 'flex') {
                return;
            }
            // console.log('ENTER pressed on input within row');
            // console.log(isLastInput);
            event.preventDefault();
            event.stopPropagation();

            if (isLastInput || (isCountEnterFinish && !serialNumberFieldExists)) {
                // Jsme v posledním vstupním poli - uložíme řádek
                if (this.checkCountAndCountAvailable(event)) {
                    if (submitButton && row.dataset.submitted !== 'true') {
                        row.dataset.submitted = 'true';
                        var addLink = document.querySelector('.row-group-actions .datagrid-toolbar .datagrid-settings a[title="Add"]');
                        var completeBtn2 = document.querySelector(this.uncompletedDocumentSelector);

                        var handleNajaComplete = () => {
                            if (addLink && !completeBtn2) this.tryOpenInlineAdd();
                            naja.removeEventListener('complete', handleNajaComplete);
                        };

                        naja.addEventListener('complete', handleNajaComplete);
                        if (submitButton) {
                            submitButton.click(); // spustí odeslání přes Naja
                        }
                    }
                } else {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;
                }
            } else if (isCountEnterFinish && serialNumberFieldExists) {
                // Speciální případ: Počítadlo s Enter Finish a pole sériových čísel existuje
                var serialNumberInput = row.querySelector('#invoice-item-serial-number');
                if (serialNumberInput && !serialNumberInput.disabled) {
                    serialNumberInput.focus();
                    serialNumberInput.click();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;
                }
            } else {
                // Nejsme v posledním vstupním poli - přesuneme fokus na další editovatelné pole
                var nextInput = editableInputs[currentIndex + 1];
                if (nextInput) {
                    nextInput.focus();

                    // Pokud jde o textové vstupní pole, vyberte celý text
                    if (nextInput.type === 'text' || nextInput.type === 'number' || nextInput.tagName.toLowerCase() === 'textarea') {
                        nextInput.select();
                    }

                    // Speciální zpracování pro pole sériového čísla
                    if (nextInput.id === 'invoice-item-serial-number' && !nextInput.disabled) {
                        // Simulovat kliknutí na pole sériového čísla po malém zpoždění
                        setTimeout(() => {
                            // Vyvolat událost kliknutí na pole sériového čísla
                            this.openSerialNumberModal(nextInput);
                        }, 50);
                    }

                    this.updateInvoiceItemPrice();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;
                }
            }
        } else if (event.key === 'Tab') {
            // Kontrola, zda se jedná o pole sériových čísel
            var isBeforeSerialNumberField =
                currentInput.name === 'inline_add[pricePurchaseBase]' ||
                currentInput.name === 'inline_edit[pricePurchaseBase]';

            var serialNumberInput = document.getElementById('invoice-item-serial-number');

            // Pokud je to pole sériových čísel a má prázdnou hodnotu, otevřeme modální okno
            if (isBeforeSerialNumberField && !serialNumberInput.disabled) {

                // Pro Tab necháme standardní chování (přechod na další pole), ale otevřeme modální okno
                // Inicializace stavu modálního okna, pokud ještě neexistuje
                if (!window.serialNumberModalState) {
                    window.serialNumberModalState = {
                        isModalOpening: false,
                        isModalOpen: false,
                        lastInput: null
                    };
                }

                // Kontrola, zda již není otevřené modální okno
                var isModalActive =
                    window.serialNumberModalState.isModalOpening ||
                    window.serialNumberModalState.isModalOpen;

                // Pokud modální okno ještě není aktivní, otevřeme ho
                if (!isModalActive) {
                    this.openSerialNumberModal(serialNumberInput);
                }
            }

            this.updateInvoiceItemPrice();
        } else if (isLastInput && (event.target.name !== "filter[serialNumber]")) {
            // Kontrola a povolení polí pro sériová čísla
            const currentRow = event.target.closest('tr');
            if (!currentRow) return false;

            const serialNumberAddField = currentRow.querySelector('input[name="inline_add[serialNumber]"]');
            const serialNumberEditField = currentRow.querySelector('input[name="inline_edit[serialNumber]"]');

            let stop = false;
            if (serialNumberAddField && serialNumberAddField.disabled) {
                stop = true;
            }

            if (serialNumberEditField && serialNumberEditField.disabled) {
                stop = true;
            }

            if (!stop) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        }
    }


// Upravme metodu pro otevření modálního okna, aby nastavila stav
    openSerialNumberModal(serialNumberInput) {
        if (!serialNumberInput || serialNumberInput.disabled) return;

        var serialNumbers = serialNumberInput.value || '';
        var url = serialNumberInput.getAttribute('data-link');

        if (!url) return;

        var updatedUrl = url.replace('SERIAL_NUMBERS', encodeURIComponent(serialNumbers));

        // Zpracování parametru repayment - nahradí placeholder REPAYMENT v URL skutečnou hodnotou
        // Jelikož Nette přidává k parametrům prefixy (cesta komponenty), hledáme parametr končící na -repayment nebo repayment, který má hodnotu REPAYMENT
        var repaymentCheckbox = serialNumberInput.closest('tr').querySelector('input[type="checkbox"][id*="repayment"]');
        var repaymentValue = (repaymentCheckbox && repaymentCheckbox.checked) ? '1' : '0';

        // Regulární výraz pro nalezení parametru končícího na repayment s hodnotou REPAYMENT
        // Hledáme vzor: ([^?&=]+repayment)=REPAYMENT
        var repaymentRegex = /([^?&=]*repayment)=REPAYMENT/g;
        if (repaymentRegex.test(updatedUrl)) {
            updatedUrl = updatedUrl.replace(repaymentRegex, '$1=' + repaymentValue);
        } else {
            // Pokud v URL placeholder REPAYMENT nebyl (např. starší verze kódu), zkusíme ho přidat pro kompatibilitu, pokud je to potřeba (ale raději ne, abychom nerozbili jiné moduly)
        }

        if ($('#frm-stockRemovalTabs-tabContent-zakladniudaje-tabControl-formEdit').length
            || $('#frm-transferEditTabs-tabContent-pridatprevodmezisklady-tabControl-formEdit').length
            || $('#frm-stockRefundTabs-tabContent-zakladniudaje-tabControl-formEdit-storeFrom').length
            || $('#frm-transferFromOtherEditTabs-tabContent-pridatprijemnasklad-tabControl-formEdit-storeFrom').length
            || $('#frm-editTabs-tabContent-polozky-tabControl-groupChanges').length
            || $('#frm-cashSaleTabs-tabContent-zakladniudaje-tabControl-formEdit').length
        ) {
            var storeCardId = document.querySelector('[name="inline_edit[_id]"]')?.value;
            if (storeCardId) {
                updatedUrl = updatedUrl.replace('DOCUMENT_ITEM_ID', storeCardId);
            } else {
                storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
                updatedUrl = updatedUrl.replace('STORE_CARD_ID', storeCardId);
            }
            var storeId = document.querySelector('[name="storeFrom"]')?.value;

            if(typeof storeId !== 'undefined') {
                updatedUrl = updatedUrl.replace('STORE_ID', storeId);
            }
        }

        // Nastavit stav otevírání modálního okna
        if (!window.serialNumberModalState) {
            window.serialNumberModalState = {
                isModalOpening: false,
                isModalOpen: false,
                lastInput: null
            };
        }

        // Nastavit stav otevírání modálního okna
        window.serialNumberModalState.isModalOpening = true;
        window.serialNumberModalState.lastInput = serialNumberInput;

        // Uložit referenci na input pole pro pozdější použití
        window.lastClickedSerialNumberInput = serialNumberInput;

        if (!serialNumberInput) {
            console.log('ERROR serialNumberInput');
            console.log(serialNumberInput);
        }

        if (!serialNumberInput) {
            console.log('ERROR serialNumberInput.closest(\'tr\')');
            console.log(serialNumberInput);
            console.log(serialNumberInput.closest('tr'));
        }


        let querySelector = window.lastClickedSerialNumberInput.closest('tr').querySelector('input[name="inline_add[count]"]');
        if (!querySelector) {
            querySelector = window.lastClickedSerialNumberInput.closest('tr').querySelector('input[name="inline_edit[count]"]');
        }

        // Uložit referenci na počet položek
        this.expectedSerialNumberCount = querySelector.value;

        // Resetovat příznaky
        window.serialNumberWarningShown = false;
        window.serialNumbersUpdated = false;

        naja.makeRequest('GET', updatedUrl, null, {
            history: false
        }).then(() => {
            var modalId = 'modal-serial-number';
            var modal = document.getElementById(modalId);

            if (modal) {
                var bsModal = new bootstrap.Modal(modal);

                // Přidat posluchač událostí pro zobrazení modálního okna
                modal.addEventListener('shown.bs.modal', () => {
                    window.serialNumberModalState.isModalOpen = true;
                    window.serialNumberModalState.isModalOpening = false;

                    // Inicializace posluchačů událostí pro modální okno
                    // setTimeout(() => {
                    this.initSerialNumberModalEvents(modal);
                    this.focusFirstSelect2InModal(modal);
                    // }, 500);

                    // Najdi select s name="select[]" v modalu
                    const serialNumberSelect = modal.querySelector('select[name="select[]"]');
                    if (serialNumberSelect) {
                        const importButton = modal.querySelector('#importSerialNumbersBtn');
                        const importTextArea = modal.querySelector('#importSerialNumbersTextArea');

                        // Najdi formulář a získej endpoint pro kontrolu sériových čísel
                        const form = modal.querySelector('.serialNumberForm');
                        if (!form) return;

                        const checkSnUrl = form.getAttribute('data-link-check-sn');

                        if (importButton && importTextArea && importButton.dataset.listenerAttached !== '1') {
                            importButton.dataset.listenerAttached = '1';
                            importButton.addEventListener('click', () => {
                                const rawValue = (importTextArea.value || '').trim();
                                if (!rawValue) return;

                                const tokens = rawValue
                                    .split(/[,\s;]+/)
                                    .map(token => token.trim())
                                    .filter(token => token.length > 0);

                                if (!tokens.length) return;

                                const currentValues = new Set($(serialNumberSelect).val() || []);
                                const newValues = $(serialNumberSelect).val() || [];
                                const notInStock = [];
                                const options = Array.from(serialNumberSelect.options);
                                let added = false;

                                tokens.forEach(token => {
                                    if (checkSnUrl) {
                                        // Režim výdeje - hledáme v existujících options
                                        const foundOption = options.find(opt => opt.value === token || opt.text === token);

                                        if (foundOption) {
                                            if (currentValues.has(foundOption.value)) return;
                                            newValues.push(foundOption.value);
                                            currentValues.add(foundOption.value);
                                            added = true;
                                        } else {
                                            notInStock.push(token);
                                        }
                                    } else {
                                        // Režim příjmu - přidáváme nové
                                        if (currentValues.has(token)) return;
                                        const option = new Option(token, token, true, true);
                                        serialNumberSelect.appendChild(option);
                                        newValues.push(token);
                                        currentValues.add(token);
                                        added = true;
                                    }
                                });

                                if (added) {
                                    $(serialNumberSelect).val(newValues).trigger('change');
                                }

                                if (notInStock.length > 0) {
                                    const flashMessage = $(`<div class="alert-danger alert mt-3 alert-dismissible fade show">
                                        Následující sériová čísla nebyla přidána, nejsou skladem: ${notInStock.join(', ')}
                                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                    </div>`);
                                    $('.alert-fixed').append(flashMessage);
                                    setTimeout(function () {
                                        flashMessage.find('.btn-close').click();
                                    }, 8000);
                                }

                                const selectTabLink = modal.querySelector('#tab-select');
                                if (selectTabLink) {
                                    selectTabLink.click();
                                }

                                if (typeof naja !== 'undefined' && typeof naja.dispatchEvent === 'function') {
                                    naja.dispatchEvent(new CustomEvent('complete', { detail: {} }));
                                }
                            });
                        }

                        if (!checkSnUrl) return;

                        // Napojení události na již inicializovaný select2
                        $(serialNumberSelect).on('select2:select', function (e) {
                            // Získání přidané hodnoty
                            const serialNumber = e.params.data.text;
                            const serialNumberOptionId = e.params.data.id;

                            var storeCardId = document.querySelector('[name="inline_edit[_id]"]')?.value;
                            var endpoint = checkSnUrl;
                            if (storeCardId) {
                                endpoint = endpoint.replace('DOCUMENT_ITEM_ID', storeCardId);
                            } else {
                                storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
                                endpoint = endpoint.replace('STORE_CARD_ID', storeCardId);
                            }
                            var storeId = document.querySelector('[name="storeFrom"]')?.value;

                            endpoint = endpoint.replace('STORE_ID', storeId);
                            endpoint = endpoint.replace('SERIAL_NUMBER', serialNumber);

                            // Kontrola sériového čísla pomocí naja
                            naja.makeRequest('POST', endpoint, {}, {history: false})
                                .then(response => {
                                    if (response.exists) {
                                        // Pokud sériové číslo existuje, zobrazit chybovou zprávu
                                        let errorElement = modal.querySelector('.serial-number-error');
                                        if (!errorElement) {
                                            errorElement = document.createElement('div');
                                            errorElement.className = 'serial-number-error text-danger mb-2';
                                            // console.log(serialNumberSelect);
                                            // console.log(serialNumberSelect.parentNode);
                                            serialNumberSelect.parentNode.insertBefore(errorElement, serialNumberSelect);
                                        }
                                        errorElement.textContent = 'Toto sériové číslo již existuje!';

                                        // Odstranění přidané hodnoty
                                        const values = $(serialNumberSelect).val();
                                        const index = values.indexOf(serialNumberOptionId);
                                        if (index > -1) {
                                            values.splice(index, 1);
                                            $(serialNumberSelect).val(values).trigger('change');
                                        }
                                    } else {
                                        // Odstraň chybovou zprávu, pokud existuje
                                        const errorElement = modal.querySelector('.serial-number-error');
                                        if (errorElement) {
                                            errorElement.remove();
                                        }

                                    }
                                })
                                .catch(error => {
                                    console.error('Chyba při kontrole sériového čísla:', error);
                                });
                        });
                        $(serialNumberSelect).on('select2:open', function () {
                            const searchInput = document.querySelector('.select2-container--open .select2-search__field');
                            if (!searchInput) return;

                            searchInput.addEventListener('input', () => {
                                // console.log('select2 search:', searchInput.value);
                                var pastedValue = searchInput.value;
                                if(pastedValue.indexOf(',') !== -1) {
                                    // odstranit čárku a vše za ní
                                    pastedValue = pastedValue.split(',')[0];
                                }
                                // nastavit hodnotu zpět do vyhledávacího pole
                                searchInput.value = pastedValue;

                            }, { once: false });
                        });
                    }
                });

                // Přidat posluchač událostí pro zavření modálního okna
                modal.addEventListener('hidden.bs.modal', () => {
                    window.serialNumberModalState.isModalOpen = false;

                    // Přidat jednorázový posluchač na dokončení NAJA požadavku
                    if (typeof naja !== 'undefined' && window.serialNumbersUpdated) {
                        var completeHandler = () => {
                            naja.removeEventListener('complete', completeHandler);

                            // Najít tlačítko pro odeslání formuláře
                            var addButton = document.querySelector('input[name="inline_edit[submit]"]');
                            if (!addButton) {
                                addButton = document.querySelector('input[name="inline_add[submit]"]');
                            }
                            if (addButton) {
                                this.simulateClickAndSubmit(addButton, false);
                            }
                        };

                        naja.addEventListener('complete', completeHandler);
                    }
                });

                bsModal.show();
            }
        }).catch(error => {
            // Resetovat stav v případě chyby
            window.serialNumberModalState.isModalOpening = false;
            console.error('Chyba při načítání modálního okna sériového čísla:', error);
        });
    }


// Rozšířená metoda pro zaměření na Select2
    focusFirstSelect2InModal(modal) {
        setTimeout(() => {
            var select2Element = modal.querySelector('select.select2-hidden-accessible');
            if (select2Element) {
                try {
                    $(select2Element).select2('open');
                } catch (e) {
                    console.error('Chyba při zaměřování Select2:', e);

                    // Záložní metoda: Simulace kliknutí na Select2 kontejner
                    var select2Container = modal.querySelector('.select2-container');
                    if (select2Container) {
                        select2Container.click();
                    }
                }
            }
        }, 300);
    }


    // Upravená metoda pro inicializaci událostí v modálním okně sériových čísel
    initSerialNumberModalEvents(modal) {
        // Najít formulář v modálním okně
        var form = modal.querySelector('form');
        if (!form) return;

        // Najít tlačítko submit
        var submitButton = form.querySelector('button[name="submitBack"], input[name="submitBack"]');
        if (!submitButton) return;

        // Najít select2 element pro sériová čísla
        var serialSelect = form.querySelector('select.select2-hidden-accessible');
        var serialNumbersText = form.querySelector('textarea.serial-numbers-text');
        if (!serialSelect && !serialNumbersText) return;

        // Uložit počet očekávaných sériových čísel
        var expectedCount = this.expectedSerialNumberCount || 1;

        // Příznak, zda bylo zobrazeno upozornění o neúplném počtu sériových čísel
        window.serialNumberWarningShown = window.serialNumberWarningShown || false;

        // Funkce pro aktualizaci počtu záznamů v elementech .currentSnCount
        const updateSelect2Count = () => {
            // Pokud existuje select2 a je inicializován
            if ($(serialSelect).length && $(serialSelect).data('select2')) {
                // Získání počtu všech záznamů
                var totalCount = serialSelect.querySelectorAll('option:checked').length;

                form.querySelector('.currentSnCount').textContent = totalCount;
                form.querySelector('.maxSnCount').textContent = this.expectedSerialNumberCount;
            }
        };

        // Inicializace počítadla po načtení select2
        setTimeout(() => {
            updateSelect2Count();

            // Přidání posluchače událostí pro všechny změny v select2
            $(serialSelect).on('change select2:select select2:unselect', function () {
                setTimeout(() => {
                    updateSelect2Count();
                }, 100);
            });
        }, 100);


        // Nastavit posluchač události pro select2 při změně hodnoty
        $(serialSelect).on('select2:select', (e) => {
            // Po každém přidání sériového čísla zkontrolujeme počet
            setTimeout(() => {
                var selectedOptions = $(serialSelect).select2('data');
                var currentCount = selectedOptions.length;

                // Pokud jsme dosáhli očekávaného počtu, přesuneme fokus na tlačítko Uložit
                if (currentCount >= expectedCount) {
                    submitButton.focus();
                }
            }, 100);
        });

        // Nastavit posluchač klávesy Enter pro select2 kontejner
        $(serialSelect).on('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();

                var selectedOptions = $(serialSelect).select2('data');
                var currentCount = selectedOptions.length;

                // Zkontrolovat počet sériových čísel
                if (currentCount < expectedCount) {
                    if (!window.serialNumberWarningShown) {
                        window.serialNumberWarningShown = true;
                        alert('Pozor, nezadal jste všechna sériová čísla, pokud je to v pořádku, pokračujte s uložením.');
                    }
                }

                // Přesunout fokus na tlačítko Uložit
                submitButton.focus();
            }
        });

        // Přidat posluchače události pro tlačítko Uložit
        if (!submitButton.classList.contains('sn-submit-handler')) {
            submitButton.classList.add('sn-submit-handler');

            // Přidat posluchač události pro kliknutí na tlačítko Uložit
            submitButton.addEventListener('click', (event) => {

                // Počet vybraných sériových čísel
                var selectedOptions = $(serialSelect).select2('data');
                // console.log(selectedOptions);
                if(!selectedOptions || selectedOptions.length === 0) {
                    // console.log($(serialNumbersText).val());
                    selectedOptions = $(serialNumbersText)
                        .val()
                        .split(/[,\r\n;]+/)
                        .map(sn => sn.trim())
                        .filter(sn => sn.length > 0)
                        .map(sn => ({ id: sn, text: sn }));
                }
                // console.log(selectedOptions);
                var selectedCount = selectedOptions.length;

                // Aktualizovat hodnotu v původním input poli pro sériová čísla
                if (window.lastClickedSerialNumberInput) {
                    // Získat hodnoty vybraných sériových čísel
                    var serialNumbers = selectedOptions.map(option => option.text || option.id).join(',');
                    if (!serialNumbers) {
                        serialNumbers = serialNumbersText.value;
                    }
                    window.lastClickedSerialNumberInput.value = serialNumbers;

                    let querySelector = window.lastClickedSerialNumberInput.closest('tr').querySelector('input[name="inline_add[count]"]');
                    if (!querySelector) {
                        querySelector = window.lastClickedSerialNumberInput.closest('tr').querySelector('input[name="inline_edit[count]"]');
                    }
                    querySelector.value = selectedCount;

                    // var selectedOptions = $(serialSelect).select2('data'); -- pokud jsem tam vlozil z serialNumbersText, tak se to prepsalo
                    var currentCount = selectedOptions.length;

                    console.log('Expected vs Current SN count:', expectedCount, currentCount);

                    // Zkontrolovat počet sériových čísel
                    if (currentCount < expectedCount) {
                        if (!window.serialNumberWarningShown) {
                            window.serialNumberWarningShown = true;
                            alert('Pozor, nezadal jste všechna sériová čísla.');
                            event.preventDefault();
                            event.stopPropagation();
                            var modalBackdrop = document.querySelector('.modal-backdrop');
                            if (modalBackdrop) {
                                modalBackdrop.remove();
                            }
                            return;
                        }
                    }

                    this.updateInvoiceItemPrice();

                    // Příznak, že došlo k aktualizaci sériových čísel
                    window.serialNumbersUpdated = true;

                    var addButton = document.querySelector('input[name="inline_edit[submit]"]');
                    if (!addButton) {
                        addButton = document.querySelector('input[name="inline_add[submit]"]');
                    }
                    if (addButton) {
                        if (submitButton && addButton.dataset.submitted !== 'true') {
                            addButton.dataset.submitted = 'true';
                            // Simulovat kliknutí na tlačítko pro přidání
                            var completeHandler = () => {
                                naja.removeEventListener('complete', completeHandler);
                                this.simulateClickAndSubmit(addButton, true);
                            };

                            naja.addEventListener('complete', completeHandler);
                        }
                    }
                }
            });
        }

        // Přidat posluchač události pro stisk klávesy Enter, když je fokus na tlačítku
        submitButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                submitButton.click();
            }
        });
    }

// Nová metoda pro simulaci kliku a odeslání formuláře
    simulateClickAndSubmit(button, clickAddLinkAfter = false) {
        if (!button) return;

        try {
            // Zkontrolujeme, zda jsou všechna povinná pole vyplněna
            var form = button.closest('form');
            if (!form) return;

            var isEdit = document.querySelector('input[name="inline_edit[submit]"]');
            var storeCardInput = document.getElementById('invoice-item_add-store-card');
            var nameInput = document.getElementById('invoice-item-name');
            var countInput = isEdit ? document.querySelector('input[name="inline_edit[count]"]') : document.getElementById('invoice-item-count');
            // var priceInput = isEdit ? document.querySelector('input[name="inline_edit[price]"]') : document.getElementById('invoice-item-price');

            // Kontrola povinných polí
            if (!isEdit && storeCardInput && !storeCardInput.value) {
                console.error('Chybí ID skladové karty');
                return;
            }

            if (!isEdit && nameInput && !nameInput.value) {
                console.error('Chybí název produktu');
                return;
            }

            if (countInput && (!countInput.value || parseFloat(countInput.value, 10) <= 0)) {
                if(countInput.dataset.serialNumbersResult === 'true') {
                    console.error('Neprošlo ověření sériových čísel, nastaven počet na 0');
                    alert('Neprošlo ověření sériových čísel, zkontrolujte zadaná sériová čísla a zkuste to znovu.');
                    document.querySelector('input[name="inline_add[cancel]"]').click();
                    return;
                }
                console.log('Nastavit výchozí hodnotu');
                countInput.value = '1'; // Nastavit výchozí hodnotu
            }

            // if (priceInput && (!priceInput.value || parseFloat(priceInput.value) <= 0)) {
            //     console.error('Chybí cena produktu');
            //     return;
            // }

            // Aktualizace ceny před odesláním
            this.updateInvoiceItemPrice();

            // Zkusit odeslat formulář pomocí NAJA frameworku
            // if (typeof naja !== 'undefined') {
            //     var formData = new FormData(form);
            //     var action = form.getAttribute('action') || window.location.href;
            //
            //     // Přidat hodnotu tlačítka do odesílaných dat
            //     formData.append(button.name, button.value);
            //
            //     // Odeslat formulář pomocí NAJA
            //     naja.makeRequest('POST', action, formData, {
            //         history: false,
            //         responseType: 'document'
            //     }).then(response => {
            //         // Po úspěšném odeslání aktualizovat grid
            //         var grid = document.querySelector('[id$="-grid"]');
            //         if (grid) {
            //             // Aktualizovat grid
            //             naja.snippetHandler.updateSnippets(response.snippets);
            //         }
            //     }).catch(error => {
            //         console.error('Chyba při odesílání formuláře:', error);
            //         // Záložní metoda - standardní kliknutí na tlačítko
            //         button.click();
            //     });
            // } else {
            // Záložní metoda - standardní kliknutí na tlačítko
            setTimeout(() => {
                button.click();
                if (clickAddLinkAfter){
                    setTimeout(() => {
                        var addLink = document.querySelector('.row-group-actions .datagrid-toolbar .datagrid-settings a[title="Add"]');

                        var handleNajaComplete = () => {
                            if (addLink) this.tryOpenInlineAdd();
                            naja.removeEventListener('complete', handleNajaComplete);
                        };

                        naja.addEventListener('complete', handleNajaComplete);
                    }, 300);
                }
            }, 300);
            // }
        } catch (error) {
            console.error('Chyba při simulaci odeslání formuláře:', error);
            // Záložní metoda - standardní kliknutí na tlačítko
            button.click();
        }
    }


// Upravíme metodu checkCountAndCountAvailable pro ošetření sériových čísel
    checkCountAndCountAvailable(event) {
        if (this.invoiceItemCount && this.invoiceItemCountAvailable) {
            var count = parseFloat(this.invoiceItemCount.value, 10);
            var countAvailable = parseFloat(this.invoiceItemCountAvailable.value, 10);

            if (this.invoiceItemRepayment?.checked) {
                return true;
            }

            if (this.allowsNegativeOutput()) {
                // Enter volá kontrolu dvakrát (klávesa + odeslání), upozornit stačí jednou na tentýž počet
                if (count && !isNaN(countAvailable) && count > countAvailable && this.invoiceItemCount.dataset.negativeWarned !== String(count)) {
                    this.invoiceItemCount.dataset.negativeWarned = String(count);
                    alert(`Není dostatek zboží skladem (skladem ${countAvailable}). Sklad povoluje výdej do záporu, stav půjde do mínusu.`);
                }
            } else if (count && countAvailable >= 0 && count > countAvailable) {
                // event.preventDefault();
                // event.stopPropagation();
                this.invoiceItemCount.value = countAvailable;
                alert(`Není dostatek zboží skladem. Maximální počet je ${countAvailable}.`);
                // return false;
            }
        }

        // Kontrola sériového čísla
        var serialNumberInput = document.getElementById('invoice-item-serial-number');
        if (!serialNumberInput) {
            serialNumberInput = document.getElementById('document-item-serial-number');
        }

        if (serialNumberInput && !serialNumberInput.disabled) {

            var serialNumberCount = serialNumberInput.value.split(',').length;
            var count = parseFloat(this.invoiceItemCount.value, 10);

            if ((!serialNumberInput.value || serialNumberInput.value.trim() === '') || serialNumberCount != count) {
                event.preventDefault();
                event.stopPropagation();
                // Pokud je požadováno sériové číslo, ale není zadáno, zobrazíme upozornění
                alert('Prosím vyplňte sériové číslo.');

                return false;
            }
        }

        if ($('.disable-check-store-card-exists').length) return true;

        var storeCardId = document.querySelector('[name="inline_edit[_id]"]')?.value;
        if (!storeCardId) {
            storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
        }

        if (!storeCardId || storeCardId === '') {
            this.showAddProductModal();
            return false;
        }

        return true;
    }


    createSuggestionsContainer() {
        var container = document.createElement('div');
        container.id = 'suggestions-container';
        container.classList.add('list-group');
        container.classList.add('ignore-form-dialog');
        container.style.position = 'absolute';
        container.style.zIndex = '9999';
        container.style.maxHeight = '35vh';
        container.style.height = 'auto';
        container.style.overflowY = 'auto';
        document.body.appendChild(container);
        return container;
    }

    // Naja si AbortController vytváří samo a ven ho vystavuje jen přes 'start' event.
    // Registrujeme se na něj jednou (stejný idiom jako naja.__inlineAddFocusBound výše)
    // a controller si uložíme do objektu předaného v options, ať víme, co rušit.
    static bindAutocompleteAbort() {
        if (naja.__autocompleteAbortBound) {
            return;
        }
        naja.addEventListener('start', (event) => {
            const {abortController, options} = event.detail;
            if (options.autocompleteAbortTarget) {
                options.autocompleteAbortTarget.controller = abortController;
            }
        });
        naja.__autocompleteAbortBound = true;
    }

    loadSuggestions(ignoreSameQuery = false) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            var query = this.invoiceItemNameInput.value;
            var provide = this.invoiceItemNameInput.getAttribute('data-provide');
            var isEan = false;
            var isInternalNumber = false;

            if (query.length === 13) isEan = true;
            if (query.length === 6) isInternalNumber = true;

            if (query.length <= 2) {
                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';
                return;
            }

            // Každý dotaz dostane rostoucí pořadové číslo. Zobrazí se vždy jen odpověď
            // na aktuálně nejnovější dotaz – tím se žádný stisk klávesy neztratí a
            // zastaralá odpověď (např. na "mv-1", když už je v poli "mv-16") se zahodí.
            const requestId = ++this.requestSeq;

            // Samotné zahození odpovědi nestačí – server ji stejně celou dopočítá a protože
            // PHP drží na session exkluzivní zámek, řadí se requesty za sebe a ten poslední
            // (na kterém záleží) čeká na všechny předchozí. Zastaralý dotaz proto rovnou rušíme.
            InvoiceForm.bindAutocompleteAbort();
            this.pendingSuggestRequest?.controller?.abort();
            const abortTarget = {};
            this.pendingSuggestRequest = abortTarget;

            // Novější dotaz => schovej dosud zobrazené (už zastaralé) možnosti a čekej na svou odpověď.
            this.suggestionsContainer.innerHTML = '';
            this.suggestionsContainer.style.display = 'none';
            this.invoiceItemNameInput.classList.add('loading');

            const inputRect = this.invoiceItemNameInput.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const isBottomQuarter = inputRect.bottom > (viewportHeight * 0.60);

            if (isBottomQuarter) {
                this.suggestionsContainer.style.bottom = `${viewportHeight - (inputRect.top + window.scrollY)}px`;
                this.suggestionsContainer.style.top = 'auto';
            } else {
                this.suggestionsContainer.style.top = `${inputRect.bottom + window.scrollY}px`;
                this.suggestionsContainer.style.bottom = 'auto';
            }

            this.suggestionsContainer.style.left = `${inputRect.left + window.scrollX}px`;
            this.suggestionsContainer.style.width = `${inputRect.width * 4}px`;

            naja.makeRequest('POST', provide, {query}, {history: false, autocompleteAbortTarget: abortTarget})
                .then(response => {
                    // Zobraz jen odpověď na nejnovější dotaz a jen pokud se obsah pole mezitím nezměnil.
                    if (requestId !== this.requestSeq) return;
                    if (this.invoiceItemNameInput.value !== query) return;
                    const totalCount = response.totalCount ?? null;
                    const sorted = Object.values(response).filter(v => typeof v === 'object' && v !== null).sort((a, b) => a.name.localeCompare(b.name, 'cs'));
                    this.displaySuggestions(sorted, query, isEan, isInternalNumber, totalCount);
                })
                .catch(() => {})
                .finally(() => {
                    // 'loading' indikátor sundej jen když dobíhá poslední (nejnovější) dotaz
                    if (requestId === this.requestSeq) {
                        this.invoiceItemNameInput.classList.remove('loading');
                    }
                });
        }, 200);
    }

    displaySuggestions(suggestions, query, isEan, isInternalNumber, totalCount) {
        this.suggestionsContainer.innerHTML = '';
        this.suggestionsContainer.style.display = 'flex';
        this.suggestionsContainer.style.flexDirection = 'column';

        const header = document.createElement('div');
        header.style.cssText = 'padding: 8px 10px; font-size: 1em; color: #000; background: #f0f4f8; border: 1px solid #838383; font-weight: bold;';
        const displayedCount = suggestions.length;
        header.textContent = (totalCount !== null && totalCount > displayedCount)
            ? `Zobrazuji ${displayedCount} z ${totalCount} záznamů`
            : `Zobrazuji ${displayedCount} záznamů`;
        this.suggestionsContainer.appendChild(header);
        suggestions.forEach((product, index) => {
            var id = product.id;
            var item = document.createElement('a');
            item.classList.add('list-group-item', 'list-group-item-action', 'ignore-form-dialog');
            if (index === 0){
                item.classList.add('highlighted');
                item.style.background = '#fff';
            }
            item.style.backgroundColor = 'rgb(232, 245, 252)';
            item.appendChild(this.prepareListGroupItem(product, query));

            // Přidání událostí pro hover a stylování
            item.addEventListener('mouseenter', () => {
                // Odstraníme zvýraznění ze všech položek
                this.suggestionsContainer.querySelectorAll('.list-group-item').forEach(el => {
                    el.classList.remove('highlighted');
                    el.style.backgroundColor = 'rgb(232, 245, 252)';
                });

                // Zvýrazníme aktuální položku
                item.classList.add('highlighted');
                //item.style.background = '#f0f0f0';
            });

            item.addEventListener('mouseleave', () => {
                if (!item.classList.contains('highlighted')) {
                    item.style.backgroundColor = 'rgb(232, 245, 252)';
                }
            });

            item.addEventListener('click', () => {
                this.setupStoreCardToRow(product, id);
            });

            if(isEan && product.ean === query){
                item.click();
                return;
            }

            if(isInternalNumber && product.internalNumber === query){
                item.click();
                return;
            }

            this.suggestionsContainer.appendChild(item);
        });
    }

    setupStoreCardToRow(product, id) {
        var itemName = document.getElementById('invoice-item-name');
        if (itemName) {
            itemName.value = product.name;
        }
        var storeCard = document.getElementById('invoice-item-store-card');
        if (storeCard) {
            storeCard.value = id;
        }

        // Zbývající kód zůstává stejný...
        var storeCardAdd = document.getElementById('invoice-item_add-store-card');
        if (storeCardAdd) {
            storeCardAdd.value = id;
        }
        var itemPricePurchase = document.getElementById('invoice-item-price-purchase');
        if (itemPricePurchase) {
            itemPricePurchase.value = sumPriceWithFees(product.pricePurchase, product.feeRecycle, product.feeCopyright);
        }
        var itemPrice = document.getElementById('invoice-item-price');
        if (itemPrice) {
            itemPrice.value = product.priceSale;
        }
        var itemMeasure = document.getElementById('invoice-item-measure');
        if (itemMeasure) {
            if(typeof product.measureShortcut !== 'undefined'){
                itemMeasure.value = product.measureShortcut;
            }
            else if (typeof product.measure !== 'undefined'){
                itemMeasure.value = product.measure;
            }
        }
        var itemCatalog = document.getElementById('invoice-item-catalog');
        if (itemCatalog) {
            if (itemCatalog.placeholder === 'ID') {
                itemCatalog.value = product.id ?? '';
            } else if (typeof product.number !== 'undefined') {
                itemCatalog.value = product.number;
            } else if (typeof product.catalog !== 'undefined') {
                itemCatalog.value = product.catalog;
            }
        }
        var itemInternalNumber = document.getElementById('invoice-item-internal-number');
        if (itemInternalNumber) {
            itemInternalNumber.value = product.internalNumber;
        }

        var itemSerialNumber = document.getElementById('invoice-item-serial-number');
        if (itemSerialNumber) {
            if (product.serialNumbers) {
                itemSerialNumber.removeAttribute('disabled');
            } else {
                itemSerialNumber.setAttribute('disabled', 'disabled');
            }
        }

        if (this.invoiceItemCountAvailable) {
            this.invoiceItemCountAvailable.value = product.countAvailable;
        }

        if (this.invoiceItemFees) {
            var fee = parseFloat(product.feeRecycle) + parseFloat(product.feeCopyright);
            if (!isFinite(fee)) {
                fee = 0;
            }
            if(fee > 0 && product.priceSaleTax && product.priceSaleTax > 0){
                fee = fee * (1 + parseFloat(product.priceSaleTax) / 100);
            }
            this.invoiceItemFees.value = fee.toFixed(2);
        }

        if (this.invoiceItemPriceSaleTax) {
            this.invoiceItemPriceSaleTax.value = product.priceSaleTax;
        }

        if (this.invoiceItemPriceSale) {
            var price = (parseFloat(product.priceSale)) * (1 + parseFloat(product.priceSaleTax) / 100);
            this.invoiceItemPriceSale.value = price.toFixed(2);
        }

        this.invoiceItemCount.value = 1;
        this.updateInvoiceItemPrice();

        this.suggestionsContainer.innerHTML = '';
        this.suggestionsContainer.style.display = 'none';

        const addRow = this.invoiceItemNameInput ? this.invoiceItemNameInput.closest('tr') : null;
        const rowCountInput = addRow
            ? addRow.querySelector('#invoice-item-count, #document-item-count')
            : null;
        (rowCountInput || this.invoiceItemCount).select();


        this.setupInvoiceItemEditBtn();

        if (this.invoiceItemEditInput) {
            this.invoiceItemEditInput.removeAttribute('disabled');
        }
    }

    setupInvoiceItemEditBtn(){
        document.querySelectorAll('.invoice-item-edit-btn').forEach(btn => {
            btn.disabled = false;
        });
    }

    prepareListGroupItem(product, query){
        const listGroupItem = document.createElement('span');
        var text = this.highlightMatch(product.name, query);
        if(product.clientNumber){
            text += ` (${product.clientNumber})`;
        }
        if(product.internalNumber || product.catalog || product.ean || product.priceSale || product.countAvailable !== undefined){
            text += `<br><small>`;
            if(product.internalNumber){
                text += `<u>ID</u>: ${product.internalNumber}; `;
            }
            if(product.catalog){
                text += `<u>PN</u>: ${product.catalog}; `;
            }
            if(product.ean){
                text += `<u>EAN</u>: ${product.ean}; `;
            }
            text += `</small>`;


            text += `<br><small>`;
            if(product.priceSale){
                text += `<u>Cena</u>: ${parseFloat(product.priceSale).toFixed(2)} Kč; `;
            }
            if(product.countAvailable !== undefined){
                text += `<u>Skladem</u>: ${product.countAvailable} ${product.measure || ''}; `;
            }
            text += `</small>`;
        }

        if(product.street || product.locality || product.postal){
            text += `<br><small>`;
            if(product.street){
                text += `${product.street}`;
            }
            if(product.locality){
                text += `, ${product.locality}`;
            }
            if(product.postal){
                text += `, ${product.postal}`;
            }
            text += `</small>`;
        }

        listGroupItem.innerHTML = text;
        return listGroupItem;
    }

    highlightMatch(text, query) {
        return text.replace(new RegExp(`(${query})`, 'gi'), '<strong>$1</strong>');
    }

    pad(n) { return String(n).padStart(2, '0'); }

    parseDate(str, expectTime /* true|false|undefined */) {
        if (!str) return null;
        const s = String(str).trim();

        // A) dd.MM.yyyy [HH:mm[:ss]]
        let m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
        if (m) {
            let [, dd, mm, yyyy, hh='0', mi='0', ss='0'] = m;
            if (expectTime === false) { hh = mi = ss = '0'; }
            return new Date(+yyyy, +mm-1, +dd, +hh, +mi, +ss, 0);
        }

        // B) yyyy-MM-dd[ T]HH:mm[:ss]
        m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
        if (m) {
            let [, yyyy, mm, dd, hh='0', mi='0', ss='0'] = m;
            if (expectTime === false) { hh = mi = ss = '0'; }
            return new Date(+yyyy, +mm-1, +dd, +hh, +mi, +ss, 0);
        }

        return null;
    }

    formatDate(date, withTime=false) {
        if (!(date instanceof Date) || isNaN(date.getTime())) return '';
        const d = this.pad(date.getDate());
        const m = this.pad(date.getMonth() + 1);
        const y = date.getFullYear();
        if (!withTime) return `${d}.${m}.${y}`;
        const hh = this.pad(date.getHours());
        const mi = this.pad(date.getMinutes());
        return `${d}.${m}.${y} ${hh}:${mi}`;
    }

    inputWantsTime(el) {
        // podle původního typu z TD inicializace; fallback = 'date'
        const t = el?.getAttribute('data-original-type') || 'date';
        return t !== 'date';
    }

    addDaysLocal(date, days) {
        // přičítání dnů v lokálním čase (omezí DST posuny)
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate(),
                            date.getHours(), date.getMinutes(), date.getSeconds(), 0);
        d.setDate(d.getDate() + days);
        return d;
    }

    daysBetweenLocal(a, b) {
        // výpočet rozdílu dnů přes „poledne“ (omezí DST posuny)
        const noon = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate(), 12, 0, 0, 0);
        const diff = noon(b) - noon(a);
        return Math.round(diff / 86400000);
    }

    updateDateTaxable() {
        const baseRaw = this.deferredDateInput.value || this.dateIssueInput.value;
        const base = this.parseDate(baseRaw, /*expectTime*/ undefined);
        if (base) {
            const showTime = this.inputWantsTime(this.dateTaxableInput);
            this.dateTaxableInput.value = this.formatDate(base, showTime);
        }
    }

    updateDateMaturity() {
        const issueRaw = this.deferredDateInput.value || this.dateIssueInput.value;
        const issue = this.parseDate(issueRaw, /*expectTime*/ undefined);
        const days = parseInt(this.maturityInput.value, 10);

        if (issue && !isNaN(days)) {
            const due = this.addDaysLocal(issue, days);
            const showTime = this.inputWantsTime(this.dateMaturityInput);
            this.dateMaturityInput.value = this.formatDate(due, showTime);
        }
    }

    updateMaturity() {
        const issueRaw = this.deferredDateInput.value || this.dateIssueInput.value;
        const issue = this.parseDate(issueRaw, /*expectTime*/ undefined);
        const due = this.parseDate(this.dateMaturityInput.value, /*expectTime*/ undefined);

        if (issue && due) {
            const diffDays = this.daysBetweenLocal(issue, due);
            this.maturityInput.value = String(diffDays);
        }
    }

    parseDecimal(value) {
        return parseFloat(String(value ?? '').replace(',', '.'));
    }

    updateInvoiceItemPrice(event = null, newCount = null) {
        let isEdit = document.querySelector('input[name="inline_edit[submit]"]');
        let row = null;
        if (isEdit) {
            row = document.querySelector('input[name="inline_edit[submit]"]').closest('tr');
        } else if (document.querySelector('input[name="inline_add[submit]"]')) {
            row = document.querySelector('input[name="inline_add[submit]"]').closest('tr');
        } else {
            return;
        }

        const active = document.activeElement;

        if (row.querySelector('#invoice-item-count')) {
            this.invoiceItemRepayment = row.querySelector('#invoice-item-repayment');
            this.invoiceItemCount = row.querySelector('#invoice-item-count');
            this.invoiceItemTaxRate = row.querySelector('#invoice-item-tax-rate');
            this.invoiceItemPrice = row.querySelector('#invoice-item-price');
            this.invoiceItemDiscount = row.querySelector('#invoice-item-discount');
            this.invoiceItemPriceBase = row.querySelector('#invoice-item-price-base');
            this.invoiceItemPricePurchase = row.querySelector('#invoice-item-price-purchase')
            this.invoiceItemPricePurchaseBase = row.querySelector('#invoice-item-price-purchase-base');
            this.invoiceItemPriceSale = row.querySelector('#invoice-item-price-sale');
            this.invoiceItemPriceSaleTax = row.querySelector('#invoice-item-price-sale-tax');
            this.invoiceItemPriceSaleTotal = row.querySelector('#invoice-item-price-sale-total');
            this.invoiceItemPriceTotal = row.querySelector('#invoice-item-price-total');
            this.invoiceItemCountAvailable = row.querySelector('#invoice-item-count-available');
            this.invoiceItemFees = row.querySelector('#invoice-item-fees');
        } else {
            this.invoiceItemRepayment = row.querySelector('#document-item-repayment');
            this.invoiceItemCount = row.querySelector('#document-item-count');
            this.invoiceItemTaxRate = row.querySelector('#document-item-tax-rate');
            this.invoiceItemPrice = row.querySelector('#document-item-price');
            this.invoiceItemDiscount = row.querySelector('#document-item-discount');
            this.invoiceItemPriceBase = row.querySelector('#document-item-price-base');
            this.invoiceItemPricePurchase = row.querySelector('#document-item-price-purchase')
            this.invoiceItemPricePurchaseBase = row.querySelector('#document-item-price-purchase-base');
            this.invoiceItemPriceSale = row.querySelector('#document-item-price-sale');
            this.invoiceItemPriceSaleTax = row.querySelector('#document-item-price-sale-tax');
            this.invoiceItemPriceSaleTotal = row.querySelector('#document-item-price-sale-total');
            this.invoiceItemPriceTotal = row.querySelector('#document-item-price-total');
            this.invoiceItemCountAvailable = row.querySelector('#document-item-count-available');
            this.invoiceItemFees = row.querySelector('#document-item-fees');
        }

        var itemCount = this.invoiceItemCount ? parseFloat(this.invoiceItemCount.value) : 1;
        if (newCount !== null) {
            itemCount = newCount;
            this.invoiceItemCount.value = itemCount;
        }

        var taxRate = this.invoiceItemTaxRate ? parseFloat(this.invoiceItemTaxRate.value) : 0;
        var discount = this.invoiceItemDiscount ? parseFloat(this.invoiceItemDiscount.value) || 0 : 0;

        if(
            active.id === this.invoiceItemPriceBase?.id
        ){
            var priceBase = this.invoiceItemPriceBase ? parseFloat(this.invoiceItemPriceBase.value) : 0;
            if (!isNaN(itemCount) && !isNaN(taxRate) && !isNaN(priceBase)) {
                var price = priceBase / itemCount / (1 - discount / 100);
                var priceTotal = priceBase * (1 + taxRate / 100);

                if (this.invoiceItemPrice) {
                    this.invoiceItemPrice.value = price.toFixed(2);
                }
                if (this.invoiceItemPriceTotal) {
                    this.invoiceItemPriceTotal.value = priceTotal.toFixed(2);
                }
                if (this.invoiceItemPricePurchaseBase) {
                    this.invoiceItemPricePurchaseBase.value = (itemCount * parseFloat(this.invoiceItemPricePurchase.value)).toFixed(2);
                }
            }
        }
        else if(active.id === this.invoiceItemPriceTotal?.id){
            var priceTotal = this.invoiceItemPriceTotal ? parseFloat(this.invoiceItemPriceTotal.value) : 0;
            if (!isNaN(itemCount) && !isNaN(taxRate) && !isNaN(priceTotal)) {
                var priceBase = priceTotal / ((1 + taxRate / 100) * (1 - discount / 100));
                var price = priceBase / itemCount;

                if (this.invoiceItemPrice) {
                    this.invoiceItemPrice.value = price.toFixed(2);
                }
                if (this.invoiceItemPriceBase) {
                    this.invoiceItemPriceBase.value = priceBase.toFixed(2);
                }
                if (this.invoiceItemPricePurchaseBase) {
                    this.invoiceItemPricePurchaseBase.value = (itemCount * parseFloat(this.invoiceItemPricePurchase.value)).toFixed(2);
                }
            }
        }
        else{
            var price = this.invoiceItemPrice ? parseFloat(this.invoiceItemPrice.value) : 0;
            var priceSale = this.invoiceItemPriceSale ? parseFloat(this.invoiceItemPriceSale.value) : 0;

            if (!isNaN(itemCount) && !isNaN(taxRate) && !isNaN(price)) {
                var priceBase = itemCount * price * (1 - discount / 100);
                var priceTotal = priceBase * (1 + taxRate / 100);

                if (this.invoiceItemPriceBase) {
                    this.invoiceItemPriceBase.value = priceBase.toFixed(2);
                }
                if (this.invoiceItemPriceTotal) {
                    this.invoiceItemPriceTotal.value = priceTotal.toFixed(2);
                }
                if (this.invoiceItemPricePurchaseBase) {
                    this.invoiceItemPricePurchaseBase.value = (itemCount * parseFloat(this.invoiceItemPricePurchase.value)).toFixed(2);
                }
            }

            if (!isNaN(itemCount) && !isNaN(priceSale)) {
                var priceSaleTotal = (itemCount * priceSale) * (1 - discount / 100);
                if (this.invoiceItemPriceSaleTotal) {
                    this.invoiceItemPriceSaleTotal.value = priceSaleTotal.toFixed(2);
                }
            }
        }
    }

    initStoreCardListener() {
        naja.addEventListener('complete', (event) => {
            const payload = event.detail.payload;
            if (payload && typeof payload.storeCard !== 'undefined' && payload.storeCard) {
                const storeCard = payload.storeCard;
                let storeCardId = document.getElementById('invoice-item_add-store-card')?.value;

                if (storeCard && typeof storeCard !== 'undefined') {
                    const storeCardEditEl = document.querySelector('input[name="inline_edit[edit]"][data-id="' + storeCard.id + '"]');
                    let row, isEditRow;

                    if (storeCardEditEl) {
                        row = storeCardEditEl.closest('tr');
                        isEditRow = true;
                    } else {
                        const addSubmit = document.querySelector('input[name="inline_add[submit]"]');
                        row = addSubmit ? addSubmit.closest('tr') : null;
                        isEditRow = false;
                    }

                    if (row) {
                        if (!isEditRow && this.invoiceItemNameInput && this.invoiceItemNameInput.value !== storeCard.name) {
                            this.invoiceItemNameInput.value = storeCard.name;
                        }

                        // Přenos hodnot z modal okna karty produktu do aktuálního řádku dokladu
                        const pricePurchaseInput = row.querySelector('#invoice-item-price-purchase') || row.querySelector('#document-item-price-purchase');
                        if (pricePurchaseInput) {
                            this.invoiceItemPricePurchase = pricePurchaseInput;
                            pricePurchaseInput.value = sumPriceWithFees(storeCard.purchasePrice, storeCard.feeRecycle, storeCard.feeCopyright);
                            this.updateInvoiceItemPrice();
                        }
                        var storeCardAdd = row.querySelector('#invoice-item_add-store-card');
                        if(!storeCardAdd){
                            storeCardAdd = document.querySelector('#invoice-item_add-store-card');
                        }
                        if (storeCardAdd) {
                            storeCardAdd.value = storeCard.id;
                        }
                        var itemMeasure = row.querySelector('#invoice-item-measure');
                        if (itemMeasure) {
                            if(typeof storeCard.measureShortcut !== 'undefined'){
                                itemMeasure.value = storeCard.measureShortcut;
                            }
                            else if (typeof storeCard.measure !== 'undefined'){
                                itemMeasure.value = storeCard.measure;
                            }
                        }
                        var itemCatalog = row.querySelector('#invoice-item-catalog');
                        if (itemCatalog) {
                            if (itemCatalog.placeholder === 'ID') {
                                itemCatalog.value = storeCard.id ?? '';
                            } else if (typeof storeCard.number !== 'undefined') {
                                itemCatalog.value = storeCard.number;
                            } else if (typeof storeCard.catalog !== 'undefined') {
                                itemCatalog.value = storeCard.catalog;
                            }
                        }

                        var itemSerialNumber = row.querySelector('#invoice-item-serial-number')
                            || row.querySelector('#document-item-serial-number');
                        if (itemSerialNumber) {
                            if (storeCard.serialNumbers) {
                                itemSerialNumber.removeAttribute('disabled');
                                itemSerialNumber.removeAttribute('readonly');
                            } else {
                                itemSerialNumber.setAttribute('disabled', 'disabled');
                                itemSerialNumber.value = '';
                            }
                        }

                        this.setupInvoiceItemEditBtn();
                        var editBtn = row.querySelector('.invoice-item-edit-btn');

                        if (editBtn) {
                            editBtn.removeAttribute('disabled');
                        }

                        const countInput = row.querySelector('#invoice-item-count') || row.querySelector('#document-item-count');
                        if (countInput && !countInput.disabled && !countInput.readOnly) {
                            countInput.focus();
                            countInput.select();
                        }
                    } else {
                        this.setupStoreCardToRow(storeCard, storeCard.id);
                    }
                }
                else{
                    this.setupStoreCardToRow(storeCard, storeCard.id);
                }
            }
        });
    }

    initAccountCodingListener() {
        const accountingCodeSelect = document.getElementById('invoice-item-accounting-code');
        const vatDivisionSelect = document.getElementById('invoice-item-vat-division');

        if (accountingCodeSelect && vatDivisionSelect && !accountingCodeSelect.classList.contains('accounting-code-listener-attached')) {
            accountingCodeSelect.classList.add('accounting-code-listener-attached');

            const specialVatId = vatDivisionSelect.dataset.specialVatDivision;
            const specialAccId = accountingCodeSelect.dataset.specialAccountingCode;

            const updateVatOptions = () => {
                const currentAccId = accountingCodeSelect.value;

                Array.from(vatDivisionSelect.options).forEach(opt => {
                    if (opt.value == specialVatId) {
                        if (currentAccId == specialAccId) {
                            opt.disabled = false;
                            opt.style.display = 'block';
                        } else {
                            opt.disabled = true;
                            opt.style.display = 'none';
                            if (vatDivisionSelect.value == specialVatId) {
                                vatDivisionSelect.value = ''; // Reset if it was selected
                            }
                        }
                    }
                });
            };

            const handleAccountCodingChange = () => {
                const accountCodingId = accountingCodeSelect.value;
                const url = accountingCodeSelect.dataset.loadVatDivisionUrl;

                if (accountCodingId && url) {
                    naja.makeRequest('POST', url, { target: accountCodingId }, { history: false })
                        .then((payload) => {
                            updateVatOptions();
                            if (payload.success && payload.data.vatDivision) {
                                vatDivisionSelect.value = payload.data.vatDivision;
                                $(vatDivisionSelect).trigger('change');
                            }
                        });
                } else {
                    updateVatOptions();
                }
            };

            const handleVatDivisionChange = () => {
                const vatDivisionId = vatDivisionSelect.value;
                const url = vatDivisionSelect.dataset.loadAccountingCodeUrl;

                if (vatDivisionId && url) {
                    naja.makeRequest('POST', url, { target: vatDivisionId }, { history: false })
                        .then((payload) => {
                            if (payload.success && payload.data.accountingCode) {
                                accountingCodeSelect.value = payload.data.accountingCode;
                                updateVatOptions();
                            }
                        });
                }
            };

            accountingCodeSelect.addEventListener('change', handleAccountCodingChange);
            vatDivisionSelect.addEventListener('change', handleVatDivisionChange);
            updateVatOptions();
        }
    }

    initModalEvents(modal, storeCardId) {
        // if (window.najaModalListenerInitialized) {
        //     return;
        // }
        //
        // window.najaModalListenerInitialized = true;
        // console.log('init modal');
        // modal.addEventListener('hidden.bs.modal', () => {
        //     var link = modal.getAttribute('data-link');
        //     link = link.replace('ITEM_ID', storeCardId);
        //     naja.makeRequest('GET', link, null, {
        //         history: false
        //     }).then((payload) => {
        //         var storeCard = payload.storeCard;
        //         var storeCardId = document.getElementById('invoice-item_add-store-card')?.value;
        //
        //         console.log(payload);
        //         console.log(storeCardId);
        //
        //         if (storeCard && typeof storeCard !== 'undefined' && storeCardId && storeCard.id == storeCardId) {
        //             console.log('name');
        //             if (this.invoiceItemNameInput.value !== storeCard.name) {
        //                 this.invoiceItemNameInput.value = storeCard.name;
        //             }
        //
        //             console.log('price');
        //             this.invoiceItemPricePurchase.value = storeCard.purchasePrice;
        //             this.updateInvoiceItemPrice();
        //         }
        //     });
        // });
    }

    static initialize() {
        if (InvoiceForm.instance) {
            // Optionálně můžeš zkontrolovat, zda je potřeba znovu navázat (např. nový DOM prvek)
            return;
        }
        new InvoiceForm();
    }

    static reset() {
        InvoiceForm.instance = null;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new InvoiceForm();
    CashSaleDiscountCalculator.initialize();
});

naja.addEventListener('complete', (event) => {
    const response = event.detail && event.detail.response;
    if (!response || !response.ok) return;

    // Odpověď nese redirect – opouštíme stránku, re-inicializace by se jen
    // prala s odchodem ze stránky (viz controls/document).
    if (event.detail.payload && event.detail.payload.redirect) return;

    //timeout kvůli cyklení
    setTimeout(() => {
        new InvoiceForm();
        CashSaleDiscountCalculator.initialize();
    }, 250);
    // new InvoiceForm(); // připojí se pouze na nově vytvořené prvky
});

document.addEventListener('datagrid-inline-add-open', () => {
    new InvoiceForm();
});

document.addEventListener('click', (e) => {
    const btn = e.target.closest('.invoice-item-edit-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    let link = btn.getAttribute('data-link');
    if (!link) return;

    if (link.includes('ITEM_ID')) {
        const storeCardEl = document.getElementById('invoice-item_add-store-card');
        const storeCardId = storeCardEl ? storeCardEl.value : null;
        if (!storeCardId) return;
        link = link.replace('ITEM_ID', storeCardId);
    }

    naja.makeRequest('GET', link, null, { history: false }).then(() => {
        const modal = document.getElementById('modal-store-catalog-edit-info');
        if (modal) new bootstrap.Modal(modal).show();
        const itemId = btn.getAttribute('data-id') || document.getElementById('invoice-item_add-store-card')?.value;
        if (InvoiceForm.instance) InvoiceForm.instance.initModalEvents(modal, itemId);
    });
});

let cashSaleDiscountCalcInstance = null;

class CashSaleDiscountCalculator {
    constructor() {
        this.discountInput = document.getElementById('document-discount-percentage');
        if (!this.discountInput) return;
        this.init();
    }

    static initialize() {
        if (!document.getElementById('document-discount-percentage')) return;
        if (!cashSaleDiscountCalcInstance) {
            cashSaleDiscountCalcInstance = new CashSaleDiscountCalculator();
        } else {
            cashSaleDiscountCalcInstance.applyDiscount();
        }
    }

    parseCzPrice(text) {
        return parseFloat((text || '').replace(/[\s ]/g, '').replace(',', '.')) || 0;
    }

    formatCzPrice(value) {
        return value.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    ensureInfoEl() {
        let el = document.getElementById('cash-sale-discount-info');
        if (!el) {
            el = document.createElement('div');
            el.id = 'cash-sale-discount-info';
            el.className = 'alert alert-info py-2 mb-2';
            el.style.display = 'none';
            const grid = document.querySelector('.cash-sale-grid');
            if (grid) grid.insertAdjacentElement('afterend', el);
        }
        return el;
    }

    applyDiscount() {
        if (!this.discountInput) return;
        const discount = parseFloat(this.discountInput.value) || 0;
        const grid = document.querySelector('.cash-sale-grid');
        if (!grid) return;

        const bodyTds = grid.querySelectorAll('tbody tr:not(.datagrid-row-columns-summary) td.col-priceTotal');
        let totalOriginal = 0;

        bodyTds.forEach(td => {
            if (!td.dataset.originalPrice) {
                td.dataset.originalPrice = td.textContent.trim();
            }
            const orig = this.parseCzPrice(td.dataset.originalPrice);
            totalOriginal += orig;
            td.textContent = discount > 0
                ? this.formatCzPrice(orig * (1 - discount / 100))
                : td.dataset.originalPrice;
        });

        const footerTds = grid.querySelectorAll('tbody tr.datagrid-row-columns-summary td.col-priceTotal');
        footerTds.forEach(td => {
            if (!td.dataset.originalPrice) {
                td.dataset.originalPrice = td.textContent.trim();
            }
            const orig = this.parseCzPrice(td.dataset.originalPrice);
            td.textContent = discount > 0
                ? this.formatCzPrice(orig * (1 - discount / 100))
                : td.dataset.originalPrice;
        });

        const summaryTd = grid.querySelector('tfoot td.col-priceTotal');
        if (summaryTd) {
            if (!summaryTd.dataset.originalPrice) {
                summaryTd.dataset.originalPrice = summaryTd.textContent.trim();
            }
            summaryTd.textContent = discount > 0
                ? this.formatCzPrice(totalOriginal * (1 - discount / 100))
                : summaryTd.dataset.originalPrice;
        }

        const infoEl = this.ensureInfoEl();
        if (discount > 0) {
            const total = totalOriginal * (1 - discount / 100);
            infoEl.textContent = 'Celková cena: ' + this.formatCzPrice(total) + ' Kč (před slevou: ' + this.formatCzPrice(totalOriginal) + ' Kč)';
            infoEl.style.display = '';
        } else {
            infoEl.style.display = 'none';
        }
    }

    init() {
        if (!this.discountInput.dataset.cashSaleDiscountBound) {
            this.discountInput.dataset.cashSaleDiscountBound = '1';
            this.discountInput.addEventListener('input', () => this.applyDiscount());
            this.discountInput.addEventListener('change', () => this.applyDiscount());
        }
        this.applyDiscount();
    }
}

export default InvoiceForm;
